import axiosInstance from "../services/axiosInstance";

// Cek sesi SSO: cookie login milik api.sewoork.com dipakai bersama sewoork.com
// dan console, jadi user yang login di landing page otomatis dikenali di sini.
// Endpoint selalu 200 (authenticated true/false) sehingga tidak memicu interceptor 401.
export const checkSession = async () => {
    const response = await axiosInstance.get('../auth/session');

    return response.data?.data;
}

export const RefreshToken = async () => {

    try {

        const response = await axiosInstance.post('../auth/refresh');

        return response.data;
    } catch (error) {
        console.error("Error refreshing token:", error);
        throw error;
    }
}